import { Component } from "react";
import { Input, Form } from "antd";
import { getLangList } from '@/lib/i18n';
import { modalFromLayout } from "@/lib/antdElementFunction";

interface props {
  form?: any;
  itemInfo: any;
  handleType: string;
}

class ModalItem extends Component<props> {
  rentT: any = getLangList("rent");

  componentDidMount() {
    const { form, itemInfo, handleType } = this.props;
    const { itemName, itemDescription } = itemInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({ itemName, itemDescription });
    }
  }

  render() {
    const { form } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
      >
        <Form.Item
          label={this.rentT.ITEM}
          name="itemName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label={this.rentT.DESCRIPTION} name="itemDescription">
          <Input />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalItem;